import * as React from 'react';

import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Spin, Tooltip, Typography } from 'antd';

import { ReportDetailState } from '../../hooks/useReportDetail';

type Props = {
    reportDetail: ReportDetailState
}

export const InfoTable: React.FC<Props> = ({
    reportDetail,
}) => {
    const data = reportDetail.result;
    return (
        <div>
            <div>
                <Typography.Text style={{ margin: '0.5rem' }}>
                    テストの情報
                </Typography.Text>
                <Tooltip
                    title='MEXCBTで公開されているこのテストの情報です。'
                >
                    <InfoCircleOutlined />
                </Tooltip>
            </div>
            <table className='test-info-table'>
                <tbody>
                    <TableRow loading={!data} label='教科' value={data?.subjectName ?? '-'} />
                    <TableRow loading={!data} label='科目' value={data?.subjectChildName ?? '-'} />
                    <TableRow loading={!data} label='学年名' value={data?.gradeName ?? '-'} />
                    <TableRow loading={!data} label='平均正答率' value={`${data?.averagePer ?? '-'}%`} />
                    <TableRow loading={!data} label='難易度' value={data?.difficulty ?? '-'} />
                    <TableRow loading={!data} label='想定所要時間' value={`${data?.testTimeMin ?? '-'}`} />
                </tbody>
            </table>
        </div>
    );
};


type TableRosProps = {
    label: string
    value?: string
    loading?: boolean
}

const TableRow: React.FC<TableRosProps> = ({
    label,
    value,
    loading,
}) => {
    return value === undefined ?
        (
            <tr>
                <th colSpan={2}>{label}</th>
            </tr>
        ) :
        (
            <tr>
                <th>{label}</th>
                <td>{loading ? <Spin indicator={<LoadingOutlined spin />} size="small" /> : value}</td>
            </tr>
        );
};